export { applyThemeFromConfig } from './apply-theme';
export {
  themeConfig,
  publicPalette,
  authPublicPalette,
  privateDefaultPalette,
  type ThemeConfig,
  type PublicPalette,
  type AuthPublicPalette,
  type PrivateDefaultPalette,
} from './config';
export {
  mergeShelterBranding,
  type ShelterBrandingPartial,
} from './merge-shelter-branding';
export { sanitizeColor, sanitizeLogoUrl } from './sanitize';
